// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinuxOutlinedSvg from "@fishx/icons-svg/es/asn/LinuxOutlined";
import FishxIcon from '../components/FishxIcon';

var LinuxOutlined = function LinuxOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinuxOutlinedSvg
  }));
};

LinuxOutlined.displayName = 'LinuxOutlined';
export default React.forwardRef(LinuxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LinuxOutlined.js
// module id = 3058
// module chunks = 0